import useSWR from 'swr';

import { getUsersList } from '@/api/users';
import { ENDPOINTS } from '@/api/endpoints';
import { useUserProfile } from '@/states/user-profile';
import { isDevEnv } from '@/libs/dev-logs';

type GetUsersListResponse = Awaited<ReturnType<typeof getUsersList>>;

export const useGetUsers = () => {
  const { profile } = useUserProfile();
  const isVitaziAdmin = profile.role === 'vitaziadmin';

  // For vitaziadmin, we pass an empty string to get all users
  // The backend should handle this to return all users
  const clinicId = isVitaziAdmin ? '' : (profile.clinic_id ?? '');

  const { data, error, isLoading, mutate } = useSWR<GetUsersListResponse, Error>(
    isVitaziAdmin ? ENDPOINTS.USERS_LIST : null,
    () => getUsersList(clinicId),
    { errorRetryCount: 1, revalidateOnFocus: !isDevEnv() }
  );

  return {
    error,
    users: data ?? [],
    loading: isLoading,
    refetch: mutate,
  };
};
